import { render } from "./multiselect.vue?vue&type=template&id=3d585432"
import script from "./multiselect.vue?vue&type=script&lang=ts"
export * from "./multiselect.vue?vue&type=script&lang=ts"

import "./multiselect.vue?vue&type=style&index=0&id=3d585432&lang=scss"
script.render = render

export default script